import { batch } from 'react-redux';
import { CustomerDisplayActions } from 'src/common/redux/reducers/customer-display-reducer';
import { DeviceNotificationActions } from 'src/common/redux/reducers/device-notification-reducer';
import { TareWeightPercentagesActions } from 'src/common/redux/reducers/tare-weight-percentages-reducer';
import { CustomerDisplayScreen } from 'src/customer-display/enum/customer-display.enum';
import { showLoginScreen } from 'src/login/components/show-login-screen';
import { clearEmeraldModals } from '../../common/emerald-modal-manager/emerald-modal-manager';
import CashierPreferencesHelper from '../../common/helpers/cashier-preferences-helper';
import { store } from '../../common/redux/configure-store';
import { ItemListActions } from '../../common/redux/reducers/item-list-reducer';
import { LoginActions } from '../../common/redux/reducers/login-reducer';
import { MiddleAreaActions } from '../../common/redux/reducers/middle-area-reducer';
import { SidebarActions } from '../../common/redux/reducers/sidebar-reducer';
import { TareWeightGroupsActions } from '../../common/redux/reducers/tare-weight-groups-reducer';
import { resetScanner } from '../../devices/scanner-operations';
import { clearPinPad } from './../../devices/payment/pinpad-operations';

export const logout = async (): Promise<void> => {
  batch(() => {
    store.dispatch(ItemListActions.removeAllRecords());
    store.dispatch(SidebarActions.resetSidebar());
    store.dispatch(LoginActions.setLogout());
    store.dispatch(MiddleAreaActions.resetState());
    store.dispatch(TareWeightGroupsActions.resetTareWeightGroups());
    store.dispatch(DeviceNotificationActions.setDevicePopup(true));
    store.dispatch(CustomerDisplayActions.setScreen(CustomerDisplayScreen.LockedScreen));
    CashierPreferencesHelper.setUserDefaults();
    store.dispatch(TareWeightPercentagesActions.resetTareWeightPercentages());
  });

  resetScanner();
  clearEmeraldModals();
  showLoginScreen();

  if (store.getState().pinPad.isPinpadConfigured) {
    await clearPinPad();
  }
};
